import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { ProfileService } from '~/app/core/common/services/profile.service';
import { StoreListService } from '~/app/core/common/services/store-list.service';
import { ProfileItem } from '~/app/core/common/models/profileItem';
import {
    DataStateChangeEvent, ExcelExportEvent,
    GridComponent,
    GridDataResult,
    PageChangeEvent,
    SelectionEvent
} from '@progress/kendo-angular-grid';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { process } from '@progress/kendo-data-query';
import { Item } from '~/app/core/common/models/item';
import { ToastrService } from 'ngx-toastr';
import { ProfileCategoriesService } from '~/app/core/common/services/profile-categories.service';
import { ComponentCanDeactivate } from '~/app/shared/navigation/component-can-deactivate';
import { DialogHelperComponent } from '~/app/shared/helpers/dialog-helper';
import { throwError } from 'rxjs';
import { JwtService } from 'mclane-webauth-lib';
import { ExcelExportData } from '@progress/kendo-angular-excel-export';
import {fileExcelIcon, filePdfIcon, SVGIcon} from "@progress/kendo-svg-icons";

@Component({
    selector: 'app-profile-items',
    templateUrl: './profile-items.component.html',
    styleUrls: ['./profile-items.component.scss']
})

export class ProfileItemsComponent extends ComponentCanDeactivate implements OnInit, OnDestroy {

    public formGroup: FormGroup;
    public gridData: GridDataResult = null;
    public state: DataStateChangeEvent = {
        skip: 0,
        take: 30,
        filter: {
            logic: "or",
            filters: [],
          }
    };
    public filePdfIcon: SVGIcon = filePdfIcon;
    public fileExcelIcon: SVGIcon = fileExcelIcon;
    public items: ProfileItem[] = [];
    public selectedItem: ProfileItem = new ProfileItem();
    public loading: any;
    private editedRowIndex: number;
    private docClickSubscription: any;
    private isNew: boolean;
    private resequence = false;
    @ViewChild(GridComponent, { static: true })
    private grid: GridComponent;

    public mogUser: boolean;
    public groupIdEditable: boolean;
    public editable = false;
    public columns: any[] = [
        {
            field: 'customerItem',
            title: 'Item Number',
            width: '240',
            editable: false,
            filterable: true,
            colWidth: 160
        },
        {
            field: 'description',
            title: 'Description',
            width: '240',
            editable: false,
            filterable: true,
            colWidth: 160
        },
        { field: 'uom', title: 'Unit Of Measure', width: '150', editable: false, filterable: false, colWidth: 160 },
        {
            field: 'show',
            title: 'Show Item',
            width: '65',
            media: '(min-width: 768px)',
            editable: this.editable,
            editor: 'boolean',
            colWidth: 60
        },
        {
            field: 'critical',
            title: 'Critical Item',
            width: '65',
            media: '(min-width: 768px)',
            editable: this.editable,
            editor: 'boolean',
            colWidth: 60
        },
        {
            field: 'buildToQty',
            title: 'Build To Qty',
            width: '150',
            editable: true,
            editor: 'numeric',
            media: '(min-width: 768px)',
            colWidth: 160,
            format: ''
        },
        {
            field: 'maxQty',
            title: 'Max Qty',
            width: '150',
            editable: this.editable,
            editor: 'numeric',
            media: '(min-width: 768px)',
            colWidth: 160,
            format: '0'
        },
        {
            field: 'sequence',
            title: 'Sequence',
            width: '100',
            editable: this.editable,
            editor: 'numeric',
            colWidth: 160,
            format: '0'
        }];
    @Input() powerUserName: string;
    constructor(public _profileService: ProfileService,
        private cdr: ChangeDetectorRef,
        public _storeListService: StoreListService,
        public _profileCategoriesService: ProfileCategoriesService,
        public _formBuilder: FormBuilder,
        private _dialogHelper: DialogHelperComponent,
        private _renderer: Renderer2,
        private _toaster: ToastrService,
        private _jwtService: JwtService) {
        super();
        this.exportAllData = this.exportAllData.bind(this);
    }

    public matches = (el, selector) => (el.matches || el.msMatchesSelector).call(el, selector);

    async ngOnInit() {
        this.loadItems();
    }
   
    public exportAllData(): ExcelExportData {
        const items = this._profileService.filterItemsByCategory();
        const sortedItems = items;
        sortedItems.forEach((item: any) => {
            item.showString = item.show ? 'Yes' : 'No';
            item.criticalString = item.critical ? 'Yes' : 'No';
        });
        const hasFilters = this.state.filter && this.state.filter.filters && this.state.filter.filters.length > 0;

        const result: ExcelExportData = {
            data: hasFilters ? process(sortedItems, this.state).data : sortedItems,
        };
        return result;
    }
    excelExported($event: ExcelExportEvent) {
        const sheet = $event.workbook.sheets[0];
        sheet.freezePane.rowSplit = 0;
        sheet.rows.unshift({
            cells: [
                { value: 'SourceLink - Master Item List', fontSize: 20, colSpan: 4 }
            ]
        }, {
            cells: [
                { value: `Store: ${this._storeListService.pickedIdentity}`, fontSize: 20, colSpan: 4 }
            ]
        }, {
            cells: [
                { value: `Category: ${this._profileCategoriesService.selectedCategory.description}`, fontSize: 20, colSpan: 4 }
            ]
        });
        sheet.name = 'Master Item List';
    }

    exportToExcel(orderingGrid: GridComponent) {
        try {
            this.loading = true;
            setTimeout(() => {
                orderingGrid.saveAsExcel();

                this.loading = false;
            }, 100);
        } catch (ex) {
            this._dialogHelper.showConfirmDialogOkOnly('Error', 'There was a problem exporting this worksheet, please try again later').then();
            this.loading = false;
        }

    }
    exportToPDF(orderingGrid: GridComponent) {
        try {
            this.loading = true;
            setTimeout(() => {
                orderingGrid.saveAsPDF();
                this.loading = false;
            }, 100);
        } catch (ex) {
            this._dialogHelper.showConfirmDialogOkOnly('Problem', 'There was a problem exporting this worksheet, please try again later').then();
            this.loading = false;
        }


    }

    loadItems() {

        this.mogUser = this._jwtService.roles.includes('Above_Store');
        if (this._storeListService.pickedStore !== undefined && this._storeListService.pickedStore.groupId === 0) {
            this.groupIdEditable = true;
        } else {
            this.groupIdEditable = false;
        }

        if (this.mogUser) {
            this.editable = true;
        } else if (!this.mogUser && this.groupIdEditable) {
            this.editable = true;
        } else if (!this.mogUser && !this.groupIdEditable) {
            this.editable = false;
        }

        this.columns = [
            {
                field: 'customerItem',
                title: 'Item Number',
                width: '240',
                editable: false,
                filterable: true,
                colWidth: 160
            },
            {
                field: 'description',
                title: 'Description',
                width: '240',
                editable: false,
                filterable: true,
                colWidth: 160
            },
            { field: 'uom', title: 'Unit Of Measure', width: '150', editable: false, filterable: false, colWidth: 160 },
            {
                field: 'show',
                title: 'Show Item',
                width: '65',
                media: '(min-width: 768px)',
                editable: this.editable,
                editor: 'boolean',
                colWidth: 60
            },
            {
                field: 'critical',
                title: 'Critical Item',
                width: '65',
                media: '(min-width: 768px)',
                editable: this.editable,
                editor: 'boolean',
                colWidth: 60
            },
            {
                field: 'buildToQty',
                title: 'Build To Qty',
                width: '150',
                editable: true,
                editor: 'numeric',
                media: '(min-width: 768px)',
                colWidth: 160,
                format: '0'
            },
            {
                field: 'maxQty',
                title: 'Max Qty',
                width: '150',
                editable: this.editable,
                editor: 'numeric',
                media: '(min-width: 768px)',
                colWidth: 160,
                format: '0'
            },
            {
                field: 'sequence',
                title: 'Sequence',
                width: '100',
                editable: this.editable,
                editor: 'numeric',
                colWidth: 160,
                format: '0'
            }];

        this.docClickSubscription = this._renderer.listen('document', 'click', this.onDocumentClick.bind(this));
        const items = this._profileService.filterItemsByCategory();
        const sortedItems = this._profileService.sortProfileItems(items);
        this.gridData = process(sortedItems, this.state);
        this.gridData.total = sortedItems.length;
    }

    categoryClicked() {
        // TODO this is where the category screen would need updated
        this.state.skip = 0;
        const totalItems = this._profileService.filterItemsByCategory();
        this.gridData = process(totalItems, this.state);
        this.gridData.total = totalItems.length;
    }

    public cellClickHandler({ isEdited, dataItem, rowIndex }): void {
        if (isEdited || (this.formGroup && !this.formGroup.valid)) {
            return;
        }
        if(!this.editable){
            this._dialogHelper.showConfirmDialogOkOnly("Contact","You don't have access for this Order Guide. Please contact your poweruser " +this.powerUserName + ".").then();
        }
        this.saveCurrent();
        this.formGroup = this.createFormGroup(dataItem);
        this.formGroup.get("sequence").statusChanges.subscribe(newStatus => {
            // if ((currentStatus == null || currentStatus === 'VALID') && newStatus === 'INVALID') {
            //     this._dialogHelper.showToastError('Sequence value cannot exceed 9 characters', 'Validation Error', 5000);
            // }
            if (newStatus === 'INVALID') {
                this.formGroup.controls.sequence.patchValue(parseInt(this.formGroup.controls.sequence.value.toString().slice(0, 9)))
            }
        });
        this.formGroup.get("maxQty").statusChanges.subscribe(newStatus => {
            if (newStatus === 'INVALID') {
                this.formGroup.controls.maxQty.patchValue(parseInt(this.formGroup.controls.maxQty.value.toString().slice(0, 6)))
            }
        });
        this.formGroup.get("buildToQty").statusChanges.subscribe(newStatus => {
            if (newStatus === 'INVALID') {
                let buildToQtyVal = this.formGroup.controls.buildToQty.value;
                let buildToQtyLength = buildToQtyVal.toString().split('.')[0].length;
                this.formGroup.get("buildToQty").patchValue(buildToQtyVal / Math.pow(10, buildToQtyLength - 6) | 0);
                this.formGroup.controls.buildToQty.patchValue(parseInt(this.formGroup.controls.buildToQty.value.toString().slice(0, 9)))
            }
        });
        this.editedRowIndex = rowIndex;
        this.grid.editRow(rowIndex, this.formGroup);
        this.cdr.detectChanges();
    }

    public createFormGroup(dataItem: any): FormGroup {
        return this._formBuilder.group({
            'ledgerCode': dataItem.ledgerCode,
            'customerItemId': dataItem.customerItemId,
            'description': dataItem.description,
            'uom': dataItem.uom,
            'categoryDescription': dataItem.categoryDescription,
            'categoryId': dataItem.categoryId,
            'locationIds': dataItem.locationIds,
            'inventoryFrequency': dataItem.inventoryFrequency,
            'businessType': dataItem.businessType,
            'show': dataItem.show,
            'critical': dataItem.critical,
            'maxQty': new FormControl(dataItem.maxQty, Validators.max(999999)),
            'buildToQty': new FormControl(dataItem.buildToQty, Validators.max(999999)),
            'sequence': new FormControl(dataItem.sequence, Validators.max(999999999)),
            'customerItem': dataItem.customerItem
        });
    }

    selectionChangeHandler($event: SelectionEvent) {
        this.selectedItem = $event.selectedRows[0].dataItem;
        this.cdr.detectChanges();
    }

    public save(product: any): void {
        if (!product.show) {
            product.critical = false;
        }
        // TODO removed duplicate seq number for SOURCELINK-399
        // const result = this.checkforDuplicateSequence(product);
        // if (result.length > 0) {
        //     this._dialogHelper.showToastInfo('Duplicate sequence number entered, Please enter a unique value', '', 5000);
        //     return;
        // } else {
        this.replaceItems(product);
        // }
    }

    public replaceItems(product: ProfileItem) {
        if (this.checkforDirtyProperty()) {
            this._profileService.profileItem.items.map((value) => {
                if (value.customerItemId === product.customerItemId && value.categoryId === product.categoryId) {
                    console.log('Category bug fix');
                    value.maxQty = product.maxQty;
                    value.critical = product.critical;
                    value.show = product.show;
                    value.buildToQty = product.buildToQty;
                    value.updated = true;
                    if (value.categoryDescription === product.categoryDescription) {
                        value.sequence = product.sequence;
                    }
                }
            });
            this.gridData.data.map((value) => {
                if (value.customerItemId === product.customerItemId && value.categoryId === product.categoryId) {
                    value.maxQty = product.maxQty;
                    value.critical = product.critical;
                    value.show = product.show;
                    value.buildToQty = product.buildToQty;
                    if (value.categoryDescription === product.categoryDescription) {
                        value.sequence = product.sequence;
                    }
                }
            });
            this._profileService.itemsSaved = true;
        }
        if (this.formGroup.get('sequence').dirty) {
            this.resequence = true;
        }
    }

    checkIfExists(items: ProfileItem[]): Item[] {
        const itemArray = [];
        items.map((value) => {
            const categories = value.categoryDescription;
            if (categories !== null && categories !== undefined) {
                if (categories === value.categoryDescription) {
                    itemArray.push(value);
                }
            }
        });
        return itemArray;
    }

    pageChange($event: PageChangeEvent) {
        this.state.skip = $event.skip;
        this.state.take = $event.take;
        const items = this._profileService.filterItemsByCategory();
        this.gridData = process(items, this.state);
        this.gridData.total = items.length;
    }

    dataStateChange(state: DataStateChangeEvent, paging: boolean = false) {
        this.state = state;
        if (paging) {
            // Here to make sure paging doesn't effect any data change
        } else {
            const items = this._profileService.filterItemsByCategory();
            const count = items.length;
            this.gridData = process(items, this.state);
            this.gridData.total = count;
        }
    }

    checkforDirtyProperty() {
        if (!this.formGroup) {
            return;
        }
        if (this.formGroup.get('maxQty').dirty ||
            this.formGroup.get('buildToQty').dirty ||
            this.formGroup.get('critical').dirty ||
            this.formGroup.get('show').dirty ||
            this.formGroup.get('sequence').dirty) {
            return true;
        }
    }

    canDeactivate(): boolean {
        return !this._profileService.itemsSaved;
    }

    private onDocumentClick(e: any): void {
        if (this.formGroup && this.formGroup.valid &&
            !this.matches(e.target, '#productsGrid tbody *, #productsGrid .k-grid-toolbar .k-button')) {
            this.saveCurrent();
        }
    }

    private saveCurrent(): void {
        if (!this.formGroup) {
            return;
        }
        try {
            this.save(this.formGroup.value);
            this.closeEditor();
            this.resequencelist();
        } catch (error) {
            throwError(error);
            this.closeEditor();
        }

    }

    public cancelHandler() {
        this.closeEditor();
    }

    private closeEditor(): void {
        this.grid.closeRow(this.editedRowIndex);
        this.isNew = false;
        this.editedRowIndex = undefined;
        this.formGroup = undefined;
    }

    private sortSequence() {
        const totalItems = this._profileService.filterItemsByCategory();
        const itemList = this._profileService.sortProfileItems(totalItems);
        this.gridData = process(itemList, this.state);
        this.gridData.total = itemList.length;
    }

    private resequencelist() {
        if (this.resequence) {
            // this.sortSequence();
            this.resequence = false;
        }
    }

    private checkforDuplicateSequence(item: ProfileItem): ProfileItem[] {
        const items = this._profileService.filterItemsByCategory();
        return items.filter((searchitem) => item.sequence === searchitem.sequence && item.customerItemId !== searchitem.customerItemId);
    }

    ngOnDestroy(): void {
        this.gridData = null;
    }
}




